<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div class="text-sm text-center copyright text-gray-400 text-lg-start">
            © {{ new Date().getFullYear() }}, Desarrollado por <a href="https://qreventos.com" class="font-weight-bold" target="_blank">QREventos</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>